import { ChangeEvent, FC, FormEvent, useEffect, useState } from 'react';
import { SearchIcon } from '@chakra-ui/icons';
import {
  Button,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react';
import { BiX } from 'react-icons/bi';
import { TreatyUsersSearch } from '../../graphql/generated';

type UserSearchInputProps = {
  name: TreatyUsersSearch['name'];
  setName: (name?: string) => void;
};

export const UserSearchInput: FC<UserSearchInputProps> = ({
  name,
  setName,
}) => {
  const [searchValue, setSearchValue] = useState<string>(name || '');

  useEffect(() => {
    setSearchValue(name || '');
  }, [name]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setName(searchValue || '');
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleClear = () => {
    setSearchValue('');
    setName('');
  };

  return (
    <form onSubmit={handleSubmit}>
      <HStack>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="gray.400" />
          </InputLeftElement>

          <Input
            value={searchValue}
            onChange={handleChange}
            placeholder="Search by name"
            data-testid="user-search-input"
            paddingRight="4.5rem" // space for X button
            borderColor="gray.400"
            // Fix inability to click X button while focused on the input (because of its custom z-index)
            sx={{
              '&:focus': {
                zIndex: 'auto',
              },
            }}
          />

          {searchValue && (
            <InputRightElement
              // Fix X button overlapping with the header menu
              zIndex="auto"
            >
              <IconButton
                aria-label="Clear search"
                onClick={handleClear}
                data-testid="clear-user-search-input-btn"
                icon={<BiX fontSize="20" />}
                _hover={{ background: 'none', color: 'gray.500' }}
                variant="ghost"
              />
            </InputRightElement>
          )}
        </InputGroup>

        <Button
          type="submit"
          data-testid="user-search-input-submit"
          colorScheme="blue"
          shadow="sm"
          size="md"
          variant="solid"
        >
          Search
        </Button>
      </HStack>
    </form>
  );
};
